import CoopPartner from 'umg-ember-backend/components/record-explorer/for/coop-partner';

<template>
  <CoopPartner @records={{@model}} @recordType='coop-partner' />
</template>
